import { render, staticRenderFns } from "./ManpowerLabourCategory.vue?vue&type=template&id=13e40156&"
import script from "./ManpowerLabourCategory.vue?vue&type=script&lang=js&"
export * from "./ManpowerLabourCategory.vue?vue&type=script&lang=js&"
import style0 from "./ManpowerLabourCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports